<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-29 10:22:44
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Punch\AbnormalPunchReason\AbnormalPunchReason.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-28 15:15:24
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_abnormalPunchReason_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-abnormal-clock-in')"
    @new="toNew"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :height="$vuetify.breakpoint.height - 275"
        :showSelect="showSelect"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback) => {
            getList(page, perpage, callback);
          }
        "
      >
        <template v-slot:item.reason="{ item }">
          <div class="table-title text--primary">
            {{ $getCommonLangValue(item.punch_invalid_reason_name) }}
          </div>
          <div class="table-subtitle text--secondary">
            {{ $getCommonLangValue(item.punch_invalid_reason_description) }}
          </div>
        </template>
        <template v-slot:item.code="{ item }">{{
          item.punch_invalid_reason_code
        }}</template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-abnormal-clock-in')"
            :editBtn="hasBtn('edit-admin-abnormal-clock-in')"
            :viewBtn="hasBtn('view-admin-abnormal-clock-in')"
            :title="$t('label_essweb_abnormalPunchReason_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
export default {
  name: "AbnormalPunchReason",
  data() {
    return {
      search: "",
      showSelect: false,
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_abnormalPunchReason_list_punchVerifyFieldReasonLabel",
          value: "reason",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_abnormalPunchReason_list_codeLabel",
          value: "code",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_punch_invalid_reason",
        url: "/punch-invalid-reason/delete-punch-invalid-reason-table/",
        data: {
          uuids: uuid,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_abnormalPunchReason_list_deleteAbnormalPunchReasonSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/abnormal-clock-in-reason/edit/"
          : "/admin/abnormal-clock-in-reason/detail/") + uuid
      );
    },
    toNew: function () {
      this.$toPage("/admin/abnormal-clock-in-reason/add", {});
    },
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_punch_invalid_reason",
        url: "/punch-invalid-reason/get-punch-invalid-reason-list/",
        data: { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback() : null;
      });
    },
  },
};
</script>
